import AssistantMedia from "./AssistantMedia";
import BookingPageMedia from "./BookingPageMedia";
import PatientDoctorMedia from "./PatientDoctorMedia";

export const MEDIA_MAP = {
    assistant: AssistantMedia,
    patientDoctor: PatientDoctorMedia,
    bookingPage: BookingPageMedia
};

export type MediaKey = keyof typeof MEDIA_MAP;
